<template>
  <div>
    <div class="project-list-w">
      <!-- User list table -->
      <div class="project-list">
        <div class="section-title">Users</div>
        <div class="user-list-w">
        <el-table
          :data="userList"
          stripe
          style="width: 100%">
          <el-table-column
            label="First Name"
            fixed="left">
            <template slot-scope="scope">
              <p>{{scope.row.name.first}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="Last Name">
            <template slot-scope="scope">
              <p>{{scope.row.name.last}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="Email Address">
            <template slot-scope="scope">
              <el-tag>{{scope.row.email}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Status">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 'ACTIVE'" type="success">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.status === 'HOLD'" type="danger">{{scope.row.status}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Role">
            <template slot-scope="scope">
              <el-button
                size="mini"
                round
                @click="changeUserScope(scope.row.uid, scope.row.userScope)"
                :disabled="scope.row.userScope <= 1 || !canChangeScope">{{calcUserRole(scope.row.userScope)}} </el-button>
            </template>
          </el-table-column>
          <el-table-column
            v-if="canChangeStatus"
            label="Control">
            <template slot-scope="scope">
              <el-button
                round
                type="success"
                size="mini"
                v-show="scope.row.status === 'HOLD' && scope.row.userScope > 1 && scope.row.uid !== currentUid"
                @click="editUserStatus(scope.row.uid, 'ACTIVE'), editUserVisible = true">Enable </el-button>
              <el-button
                round
                size="mini"
                type="danger"
                v-show="scope.row.status === 'ACTIVE' && scope.row.userScope > 1 && scope.row.uid !== currentUid"
                @click="editUserStatus(scope.row.uid, 'HOLD'), deleteUserVisible = true">Disable</el-button>
              <div v-show="scope.row.uid === currentUid">
                Current User
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            {{canViewUsers ? 'No User Data Available' : 'Need Permission to View Users'}}
          </template>
        </el-table>
        </div>
      </div>

      <!-- Invite user on desktop -->
      <transition name="desktop-add">
        <div class="desktop-buttons" v-if="showDesktopAdd">
          <div class="desktop-add" @click="inviteUserVisible = true, showDesktopAdd = false, showAddPopW = true">
            <img src="../assets/add-user.svg" alt="desktop add button" width="40px">
            <div style="margin-top: 2px;">Invite User</div>
          </div>
        </div>
      </transition>

      <!-- Invite user on mobile -->
      <div class="buttons">
        <div class="mobile-add">
          <!-- <el-button type="primary" icon="el-icon-plus" circle @click="showAddProjectPop()"></el-button> -->
          <div class="add-float-button" @click="inviteUserVisible = true, showAddPopW = true">
            <img src="../assets/add (3).svg" alt="add float icon" width="24px">
          </div>
        </div>
      </div>
    </div>

    <!-- Invite new user pop-up -->
    <transition name="pop-w-animate">
      <div class="pop-w" v-if="showAddPopW" @click="showAddPopW = false, inviteUserVisible = false, showDesktopAdd = true, showAddPopw = false">
      </div>
    </transition>
    <div class="pop">
      <transition name="pop-card">
        <div class="project-pop-card" v-if="inviteUserVisible">
          <div class="title-w">
            <div class="title">Invite New User</div>
            <div class="close-pop"><i class="el-icon-close" @click="inviteUserVisible = false, showAddPopW = false, showDesktopAdd = true"></i></div>
          </div>
          <el-input placeholder="Enter email address" v-model="userEmail" clearable></el-input>
          <div style="margin-top: 24px; text-align: center">
            <el-button type="primary" round @click="inviteUserVisible = false, showAddPopW = false, showDesktopAdd = true, inviteUser()" :disabled="!userEmail">Send Invitation</el-button>
            <el-button round @click="inviteUserVisible = false, showAddPopW = false, showDesktopAdd = true">Cancel</el-button>
          </div>
        </div>
      </transition>
    </div>

    <!-- Change User Status -->

    <!-- <transition name="pop-w-animate">
      <div class="pop-w" v-if="showAddPopW" @click="editUserVisible = false, showAddPopw = false">
      </div>
    </transition>
    <div class="pop">
      <transition name="pop-card">
        <div class="project-pop-card" v-if="editUserVisible">
          <div class="title-w">
            <div class="title">Change User Status</div>
            <div class="close-pop"><i class="el-icon-close" @click="editUserVisible = false, showAddPopW = false"></i></div>
          </div>
          <el-select v-model="selectedStatus" placeholder="Please select a user status">
            <el-option label="Status 1" value="1"></el-option>
            <el-option label="Status 2" value="2"></el-option>
          </el-select>
          <div style="margin-top: 24px; text-align: center">
            <el-button type="primary" round @click="editUserVisible = false, showAddPopW = false, editUserStatus()" :disabled="!userEmail">Confirm</el-button>
            <el-button round @click="editUserVisible = false, showAddPopW = false">Cancel</el-button>
          </div>
        </div>
      </transition>
    </div> -->

  </div>
</template>

<script>
export default {
  name: 'UserList',
  data () {
    return {
      editUserVisible: false,
      tempUser: [],
      selectedStatus: '',

      deleteUserVisible: false,

      inviteUserVisible: false,
      userEmail: '',

      showDesktopAdd: true,
      showAddPopW: false
    }
  },
  computed: {
    canViewUsers: function () {
      // eslint-disable-next-line no-mixed-operators
      return this.$store.getters.currentUserInfo && this.$store.getters.currentUserInfo.permits.USER_VIEW || false
    },
    canChangeStatus: function () {
      // eslint-disable-next-line no-mixed-operators
      return this.$store.getters.currentUserInfo && this.$store.getters.currentUserInfo.permits.USER_STATUS_EDIT || false
    },
    canChangeScope: function () {
      // eslint-disable-next-line no-mixed-operators
      return this.$store.getters.currentUserInfo && this.$store.getters.currentUserInfo.permits.USER_SCOPE_EDIT || false
    },
    currentUid: function () {
      return this.$store.getters.currentUserInfo.uid
    },
    userList: function () {
      if (!this.canViewUsers) {
        return []
      }
      return this.$store.state.users.filter(user => (user.userScope > 0))
    }
  },
  methods: {
    editUserStatus: async function (uid, status) {
      let editResult = await this.$store.dispatch('changeUserStatus', { newStatus: status, uid: uid })
      if (editResult.success) {
        this.$message.success('User status changed')
      } else {
        this.$message.error(editResult.error)
      }
    },
    changeUserScope: async function (uid, scope) {
      if (scope < 2) {
        this.$message.warning('Modify on admin user is not allowed')
        return
      }
      if (scope - 1 < 2) {
        scope = 4
      } else {
        scope = scope - 1
      }
      let editResult = await this.$store.dispatch('changeUserScope', { newScope: scope, uid: uid })
      if (editResult.success) {
        this.$message.success('User\'s role changed')
      } else {
        this.$message.error(editResult.error)
      }
    },
    inviteUser: async function () {
      let emailAddress = this.userEmail.toLowerCase()
      if (!emailAddress) {
        this.$message.error('Please enter the email address')
        return
      }
      let inviteResult = await this.$store.dispatch('inviteUser', emailAddress)
      // console.log('inviteResult', inviteResult)
      if (inviteResult.success) {
        this.$message.success(`Invitation sent to: ${emailAddress}`)
      } else {
        this.$message.error(inviteResult.error)
      }
    },
    calcUserRole: function (userScope) {
      switch (userScope) {
        case 0:
          return 'Root'
        case 1:
          return 'Admin'
        case 2:
          return 'Office'
        case 3:
          return 'Worker'
        case 4:
          return 'Visitor'
        default:
          return 'N/A'
      }
    }
  }
}
</script>

<style scoped>
.user-list-w {
  border-radius: 20px;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 20px;
  border: solid 1px #f0f0f0;
}
.buttons {
  width: 22%;
  box-sizing: border-box;
  padding-top: 24px;
  text-align: center;
}
.mobile-add {
  display: none
}
.section-title {
  margin-top: 80px;
}

@media screen and (max-width: 991px) {
  .list-wrapper {
    display: block;
  }
  .user-list {
    width: 100%;
    padding: 0;
  }
  .buttons {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 8;
    width: auto;
    box-sizing: border-box;
    padding-top: 24px;
    text-align: center;
  }
  .desktop-add {
    display: none;
  }
  .mobile-add {
    display: block
  }
}
</style>
